import { SymptomDto } from './SymptomDto';
import { Symptom } from '../../../domain/entities/Symptom';

export const toDomain = (symptomDto: SymptomDto): Symptom => {
    return {
        key: symptomDto.key,
        description: symptomDto.descriptor,
    };
};
